import actionTypes, { MINIMUM_WAIT_FOR_RESPONSE, WAIT_TO_SHOW_CONTENT } from "./types";

import request, { CancelToken, isCancel } from "axios";

import checkStatus from "../api/check-status";
import handleProcessorErrors from "../api/handle-processor-errors";

export function updateQueryString(query = "") {
  return {
    type: actionTypes.MODAL_UPDATE_QUERY_STRING,
    query,
  };
}

export function errorReceivingCampaigns(error) {
  return {
    type: actionTypes.MODAL_ERROR_RECEIVING_CAMPAIGNS,
    error,
  };
}

export function selectCategory(selectedCategory) {
  if (selectedCategory === "") {
    selectedCategory = "";
  }
  return {
    type: actionTypes.MODAL_SELECT_CATEGORY,
    selectedCategory,
  };
}

export function definitelyStopLoader() {
  return {
    type: actionTypes.MODAL_DEFINITELY_STOP_LOADER,
  };
}

export function startLoader() {
  return {
    type: actionTypes.MODAL_START_LOADER,
  };
}

export function selectCampaign(campaign, bool) {
  return {
    type: actionTypes.MODAL_SELECT_CAMPAIGN,
    campaign,
    bool,
  };
}

export function buildUrl(dispatch, entity, options) {
  let buildableUrl = `/microsite/api/campaigns?entity_id=${entity}`;

  if (options.sectionId) {
    buildableUrl += `&section_id=${options.sectionId}`;
  }

  if (options.campaignId) {
    buildableUrl += `&campaign_id=${options.campaignId}`;
  }

  if (options.page || options.page >= 0) {
    buildableUrl += `&page=${options.page}`;
  }

  if (options.query) {
    buildableUrl += `&search=${options.query}`;
  }

  if (options.parentQuery) {
    buildableUrl += `&search=${options.parentQuery}`;
  }

  if (options.limit) {
    buildableUrl += `&limit=${options.limit}`;
  }

  if (options.category) {
    if (options.category !== "null" && options.category != "") {
      buildableUrl += `&category=${encodeURIComponent(options.category)}`;
    }

    dispatch(selectCategory(options.category));
  }

  return buildableUrl;
}

export function searchCampaigns(entity, options = {}) {
  return (dispatch, getState) => {
    dispatch(startLoader());

    const startTime = Date.now();

    const buildableUrl = buildUrl(dispatch, entity, options);

    return request(buildableUrl)
      .then((res) => {
        // dispatch actions after set timeout so the campaigns don't show
        // in the ui before the spinner is canceled
        const dispatchReceivedCampaigns = () => {
          if (options.resetCampaigns === true) {
            dispatch(
              resetAndAddNewCampaigns(res.data.campaigns, res.data.meta.total_campaigns),
            );
          } else {
            dispatch(
              receivedCampaigns(res.data.campaigns, res.data.meta.total_campaigns),
            );
          }
        };

        const endTime = Date.now();

        // toggle is loading to false if we have waited a long enough time
        // to make the ui more fluid
        if (endTime - startTime < MINIMUM_WAIT_FOR_RESPONSE) {
          setTimeout(() => {
            // dispatch(definitelyStopLoader());
            dispatchReceivedCampaigns();
          }, WAIT_TO_SHOW_CONTENT);
        } else {
          dispatch(definitelyStopLoader());
          dispatchReceivedCampaigns();
        }
      })
      .catch(({ res }) => {
        dispatch(errorReceivingCampaigns(res.data.errors));
        dispatch(definitelyStopLoader());
      });
  };
}
